import React from 'react';
import styled from 'styled-components';

type Color = 'default' | 'primary' | 'secondary';

export const ButtonRoot = styled.button.withConfig<{ color: Color }>({
  shouldForwardProp: (props: string) => !['color'].includes(props)
})`
  outline: none;
  border: none;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 40px;

  font-family: ${(props) => props.theme.typography.button.fontFamily};
  font-weight: ${(props) => props.theme.typography.button.fontWeight};
  line-height: ${(props) => props.theme.typography.button.lineHeight};
  letter-spacing: ${(props) => props.theme.typography.button.letterSpacing};
  text-transform: ${(props) => props.theme.typography.button.textTransform};
  font-size: ${(props) => props.theme.typography.button.fontSize};

  border-radius: ${(props) => props.theme.components.button.borderRadius};
  padding: ${(props) => `${props.theme.spacing(2)} ${props.theme.spacing(4)}}`};

  background-color: ${({ color, theme }) => theme.palette[color]?.main};
  color: ${({ color, theme }) => theme.palette[color]?.contrastText};

  &:disabled {
    cursor: default;
    pointer-events: none;
    background-color: ${({ theme }) => theme.palette.secondary.main};
    color: ${({ theme }) => theme.palette.action.disabledText};
  }
`;

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: Color;
}

const Button = React.forwardRef<HTMLButtonElement, Props>(function Button(props: Props, ref) {
  const { children, color = 'default', type = 'button', ...rest } = props;

  return (
    <ButtonRoot ref={ref} color={color} type={type} {...rest}>
      {children}
    </ButtonRoot>
  );
});

export default Button;
